import { useMutation } from "@tanstack/react-query";
import { trainerLectureConfirmationsApi } from "api/trainers/trainerLectureConfirmationsApi";

export const useSendTrainerLectureConfirmationRequest = () => {
  return useMutation({
    mutationFn: ({ trainerId, courseScheduleId }: { trainerId: number; courseScheduleId: number }) =>
      trainerLectureConfirmationsApi.sendRequest(trainerId, courseScheduleId),
  });
};
